<template>
  <div>
    <div>{{ langText }}</div>
    <v-text-field
      outline
      single-line
      :value="embedHtml"
      onclick="this.select()"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "vc-share-iframe-embed-html",
  data: () => ({
    isFavorited: false,
    displayFavoriteCount: 0,
    errorMessage: "",
    showErrorMessage: false
  }),
  props: {
    langText: {
      type: String,
      default: ""
    },
    embedHtml: {
      type: String,
      default: ""
    }
  }
};
</script>
